export default __webpack_public_path__ + "static/media/15_photo.ad65ea29.jpg";